import FetchStatus from "@/constants/fetch-status/FetchStatus";
import MonitoringElementType from "@/constants/monitoring-elements/MonitoringElementType";

import {
	SetGoogleMaps, SetGoogleMapsError, SetGoogleMapsMarkerStatus, SetGoogleMapsSucess,
} from "@/stores/actions/GoogleMaps";

const SetWindTurbineMarker = (windTurbine) =>
{
	const marker = {
		position: {
			lat: 0,
			lng: 0,
		},
		icon:  "",
		title: "",
		label: {
			text:       "",
			color:      "white",
			fontWeight: "bold",
			fontSize:   "12px",
		},
		Id: 0,
	};
	marker.position.lat = windTurbine.windTurbines[0].latitude;
	marker.position.lng = windTurbine.windTurbines[0].longitude;
	marker.Id = windTurbine.id;
	marker.type = windTurbine.type;
	marker.title = windTurbine.name;
	marker.label.text = windTurbine.name;

	return marker;
};

const SetWindTurbinesMarkers = (windTurbines) =>
{
	const markers = [];
	for (let i = 0; i < windTurbines.length; i++)
	{
		let marker = {};

		if (MonitoringElementType.WindTurbine === windTurbines[i].type)
		{
			marker = SetWindTurbineMarker(windTurbines[i]);
			markers.push(marker);
		}
	}
	return markers.map(((marker) =>
	{
	// Remove quem não tem lng e latitude.
		if (!!marker.position.lat && !!marker.position.lng)
		{
			return marker;
		}
	}));
};

const SetCenterMap = (markers) =>
{
	const markerArray = { lat: [], lng: [] };
	const center = { lat: 0, lng: 0 };
	for (let i = 0; i < markers.length; i++)
	{
		markerArray.lat.push(markers[i].position.lat);
		markerArray.lng.push(markers[i].position.lng);
	}
	center.lat = markerArray.lat.reduce((a, b) => a + b, 0) / markerArray.lat.length;
	center.lng = markerArray.lng.reduce((a, b) => a + b, 0) / markerArray.lng.length;
	return center;
};

const state = {
	windStatus: FetchStatus.Init,
	markers:    [],
	center:     { lat: 0, lng: 0 },
	error:      "None",
};

const actions = {
	[SetGoogleMaps]: ({ commit, dispatch }, monitoringElements) =>
	{
		commit(SetGoogleMaps);
		try
		{
			let markers = [];
			if (monitoringElements[0].type === MonitoringElementType.WindTurbine)
			{
				markers = SetWindTurbinesMarkers(monitoringElements);
			}
			const center = !!monitoringElements && monitoringElements.length > 0 ? SetCenterMap(markers) : { lat: 0, lng: 0 };
			commit(SetGoogleMapsSucess, { markers, center });
			dispatch(SetGoogleMapsMarkerStatus);
		}
		catch (error)
		{
			commit(SetGoogleMapsError, error);
		}
	},
	[SetGoogleMapsMarkerStatus]: ({
		commit, state, rootState
	}) =>
	{
		const turbinesStatus = rootState.WindPark.turbinesStatus;
		
		const updatedMarkers = state.markers.map((marker) =>
		{
			const turbineStatus = turbinesStatus.find(t => t.monitoringElementId === marker.Id);
			if (turbineStatus)
			{
				return {
					...marker,
					turbineStatus,
				};
			}
			return marker;
		});
		
		commit(SetGoogleMapsMarkerStatus, updatedMarkers);
	},

};
const mutations = {
	[SetGoogleMaps]: (state) =>
	{
		state.windStatus = FetchStatus.Loading;
	},
	[SetGoogleMapsMarkerStatus]: (state, updatedMarkers) =>
	{
		state.markers = updatedMarkers;
		state.windStatus = FetchStatus.Loaded;
	},
		
	[SetGoogleMapsSucess]: (state, resp) =>
	{
		state.center = resp.center;
		state.markers = resp.markers;
	},
	[SetGoogleMapsError]: (state, error) =>
	{
		state.windStatus = FetchStatus.Error;
		state.error = error;
	},
};

export default {
	state,
	actions,
	mutations,
};
